import React, { useEffect, useState } from "react";
import LeftVehileInformation from "./components/LeftVehileInformation";
import TwoColumn from "../components/TwoColumn";

import "./VehicleInformation.scss";
import RightVehicleInformation from "./components/RightVehicleInformation";
import { getVehicleInformationData } from "../api";
import { useSelector } from "react-redux";
import LottieLoad from "../../../components/common/ErrorComponents/LottieLoad";
import Feedback from "../../../components/common/ErrorComponents/Feedback";
import NotAuthorized from "../../../components/common/ErrorComponents/NotAuthorized";

const VehicleInformation = () => {
  const vinNumber = useSelector((state) => state.mainReducer.vin_Number);
  const [vehicleInfo, setVehicleInfo] = useState(null);
  const [notAuthorized, setNotAuthorized] = useState(false);
  const [apiError, setApiError] = useState(false);

  const getInformationData = async (payload) => {
    const { vinNumber } = payload;
    const { data, code } = await getVehicleInformationData({
      vinNumber: vinNumber,
    });

    if (code === 200 && data) {
      setVehicleInfo(data[0]);
    } else if (code === 401) {
      setNotAuthorized(true);
    } else {
      setApiError(true);
    }
  };

  useEffect(() => {
    getInformationData({
      page: 0,
      vinNumber: vinNumber,
    });
  }, []);

  if (notAuthorized) {
    return <NotAuthorized />;
  }
  if (apiError) {
    return <Feedback />;
  }
  if (!vehicleInfo) {
    return <LottieLoad />;
  }

  return (
    <TwoColumn className="vechile-information">
      {vehicleInfo ? (
        <>
          <LeftVehileInformation vehicleInfo={vehicleInfo} />
          <RightVehicleInformation vehicleInfo={vehicleInfo} />
        </>
      ) : (
        <>No data availaible</>
      )}
    </TwoColumn>
  );
};

export default VehicleInformation;
